var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',{staticStyle:{"marginBottom":"4rem"}},[_vm._v(" REPS Mobile App Privacy Policy ")]),_c('vue-markdown',[_vm._v(_vm._s(_vm.text)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }